// Reduced Task Team/Company Promo

export const tracking = {
  reducedTaskTeamCompanyPromo: {
    TOP_BAR_BANNER_DISMISS:
      'Promo: clicked reduced team or company banner dismiss',
    TOP_BAR_BANNER_UPGRADE:
      'Promo: clicked reduced team or company banner upgrade',
    TOP_BAR_BANNER_TRACKING_KEY: 'reduced_team_company_offer_banner',
  },
};
